export default "https://cdn-static.gokick.com/assets/ac567471f1b9fb2f6cedfba22f3391469dbaa38e/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";